import { createListenerMiddleware } from '@reduxjs/toolkit';
import { resetAvatarSession } from '@molecules/UserAvatar/avatarSession';
import { auth } from '@/auth';
import { AuthSlice, IAuthState, isSessionEnd } from '../reducers/AuthReducer';
import { sendNotification } from '@srm/ui/lib/notifications';

/**
 * Side-effect'ы на auth-actions — тут живёт UI-реакция на action
 * `sessionExpired` (тост «сессия истекла»), чтобы reducer оставался pure,
 * а interceptor не импортировал UI-слой.
 */
export const authListenerMiddleware = createListenerMiddleware();

authListenerMiddleware.startListening({
    actionCreator: AuthSlice.actions.sessionExpired,
    effect: (action, api) => {
        // Тост показываем только если до 401 пользователь был залогинен.
        // getOriginalState() возвращает state ДО применения action.
        const prev = api.getOriginalState() as { auth: { isAuth: boolean } };
        if (prev.auth.isAuth) {
            sendNotification({
                // Вход другого пользователя — не истечение: страница остаётся, профиль загружается новый.
                message:
                    action.payload === 'user-switch'
                        ? 'В соседней вкладке выполнен вход другим пользователем'
                        : 'Сессия истекла, вы будете перенаправлены на страницу авторизации',
                variant: 'yellow',
            });
        }
    },
});


authListenerMiddleware.startListening({
    predicate: (_action, current, previous) => {
        const next = (current as { auth: IAuthState }).auth;
        const prev = (previous as { auth: IAuthState }).auth;
        return next.isAuth !== prev.isAuth || next.user.id !== prev.user.id;
    },
    effect: (_action, api) => {
        resetAvatarSession((api.getState() as { auth: IAuthState }).auth.isAuth);
    },
});

authListenerMiddleware.startListening({
    predicate: (_action, current, previous) =>
        isSessionEnd((previous as { auth: IAuthState }).auth, (current as { auth: IAuthState }).auth),
    effect: () => auth.endSession(),
});
